import { z } from 'zod'
import errorMap from '@gap/backend/util/validations/validation-error-map'

export const orgSizes = ['Just me', '2-5', '6-10', '11-20', '21-50', '51-100', '100+'] as const

export const orgSizeEnumSchema = z.enum(orgSizes, { errorMap })
export type OrgSize = z.infer<typeof orgSizeEnumSchema>
